import { Menu } from "lucide-react";
import { Button } from "@shared/ui/Button";

export type Props = {
  onClick: () => void;
  className?: string;
};

export function SupportCategoryAccordionButton({ onClick, className }: Props) {
  return (
    <Button
      variant="secondary"
      iconComponent={Menu}
      onClick={onClick}
      className={className}
      data-testid="support-categories-open"
    >
      Categories
    </Button>
  );
}

export default SupportCategoryAccordionButton;
